export enum BucketType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export const DEFAULT_BUCKET = BucketType.INTERNAL;

const KEY_PREFIX = 'mission-control';

export const FOLDER_BUCKET: Readonly<Record<string, BucketType>> = {
  // External — merchant-facing / CDN-served assets
  'moop-images': BucketType.EXTERNAL,
  'moop-insertion-orders': BucketType.EXTERNAL,
  'edm-tiles': BucketType.EXTERNAL,
  'deal-assets': BucketType.EXTERNAL,
  'video-ads': BucketType.EXTERNAL,
  'video-ads-logos': BucketType.EXTERNAL,
  'raf-sharing-banners': BucketType.EXTERNAL,
  'crm-pop-out': BucketType.EXTERNAL,
  'crm-push-notification': BucketType.EXTERNAL,
  'crm-bulk-edit': BucketType.EXTERNAL,
  // Internal — ops-facing / presigned access only
  'merchant-approval': BucketType.INTERNAL,
  'io-attachments': BucketType.INTERNAL,
  'insertion-order-signed': BucketType.INTERNAL,
  'completion-files': BucketType.INTERNAL,
  'audit-log-attachments': BucketType.INTERNAL,
  'config-center': BucketType.INTERNAL,
};

function folderOfKey(fileKey: string): string | undefined {
  if (!fileKey) return undefined;
  const segments = fileKey.split('/');
  if (segments[0] === KEY_PREFIX && segments.length >= 3) {
    return segments[1];
  }
  if (segments.length >= 2 && segments[0] !== KEY_PREFIX) {
    return segments[0];
  }
  return undefined;
}

/** Returns the BucketType for the given S3 key; falls back to INTERNAL for unknown folders. */
export function bucketForKey(key: string): BucketType {
  const folder = folderOfKey(key);
  if (folder !== undefined && folder in FOLDER_BUCKET) {
    return FOLDER_BUCKET[folder];
  }
  return DEFAULT_BUCKET;
}
